module.exports = __webpack_public_path__ + "img/ar2.89875b41.jpg";